import styled from 'styled-components';
import colors from '../../UI/Colors/index';

/*const pulso = keyframes`
    0% {transform: scale(1);}
    50% {transform: scale(1.2);}
    100% {transform: scale(1);}
    `;

const pulsoMobile = keyframes`
    0% {transform: scale(0.8);}
    50% {transform: scale(1);}
    100% {transform: scale(0.8);}
    `;
*/
export const Container = styled.section`
  margin-top: 1px;
  padding: 100px 60px;
  background: ${colors.gray_primary};
  @media (max-width: 1000px) {
    padding: 70px 30px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 100vw;
  margin: 0 auto;
  //background: blue;
`;

export const ColumnLeft = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  //background-color: red;
  padding-left: 40px;
  > img {
    padding-top: 35px;
  }
  @media (max-width: 600px) {
    width: 95%;
    margin-left: 0px;
    padding-left: 10px;
  }
`;

export const Description = styled.p`
  font-family: Muli;
  font-style: normal;
  font-weight: 300;
  font-size: 25px;
  line-height: 149.3%;
  text-align: left;
  color: #333333;
  margin-bottom: 20px;
  padding-right: 60px;
  //padding-left: 40px;
  @media (max-width: 800px) {
    font-size: 18px;
  }
  @media (max-width: 600px) {
    font-size: 14px;
    padding-right: 0px;
  }
  @media (max-width: 500px) {
    font-size: 18px;
  }
`;

export const Row = styled.div`
  //background: pink;
  display: grid;
  grid-template-columns: 47vw 38vw;
  grid-gap: 42px;
  //padding-left: 40px;
  @media (max-width: 800px) {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    //background: pink;
  }
`;

export const Link = styled.a`
  width: 233px;
  height: 45px;

  background: #1e88e5;
  border-radius: 15px;
  font-family: Mulish;
  font-style: normal;
  font-weight: 600;
  font-size: 25px;
  line-height: 149.3%;
  color: #ffffff;
  padding-top: 3px;
  text-decoration: none;
  //margin-left: 40px;
  &:hover {
    color: #9b9999;
    background: ${colors.blue_footer}
    transition: 200ms ease-in;
    text-decoration: none;
  }
  @media (max-width: 600px) {
    width: 183px;
    height: 35px;
    padding-top: 1px;
    font-size: 20px;
  }
`;

export const TitleSection = styled.h3`
  //margin-bottom: 20px;
  font-family: Muli;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 115%;
  text-align: justify;
  text-transform: uppercase;
  margin-top: 15px;
  color: #4070ff;
  padding-left: 40px;
  @media (max-width: 600px) {
    padding-left: 10px;
  }
`;

export const Line = styled.div`
  width: 217px;
  height: 6px;
  background: #4070ff;
  border-radius: 10px;
  margin-top: 1px;
  margin-bottom: 20px;
  margin-left: 40px;
  @media (max-width: 600px) {
    margin-left: 10px;
  }
`;

export const SubTitle = styled.h4`
  font-family: Muli;
  font-style: normal;
  font-weight: 600;
  font-size: 25px;
  line-height: 115%;
  text-align: left;
  text-transform: capitalize;
  margin-top: 30px;
  margin-bottom: 20px;
  color: #333333;
`;
